import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"data-icon": "edit",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.0957 5.40454L18.5959 9.90474",
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.62685 19.8738C8.47947 20.0212 8.28973 20.1188 8.08414 20.1531L4.38095 20.7703C3.70413 20.8831 3.11736 20.2963 3.23016 19.6195L3.84736 15.9163C3.88162 15.7107 3.97927 15.521 4.12664 15.3736L15.9732 3.52704C16.3107 3.18958 16.7685 3 17.2458 3C17.7232 3 18.1809 3.18958 18.5185 3.52704L20.4734 5.48193C20.8108 5.81949 21.0004 6.27727 21.0004 6.75458C21.0004 7.2319 20.8108 7.68968 20.4734 8.02724L8.62685 19.8738Z",
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
export default SvgEdit;
